/**
 * The pricing tables, edits, bookmarks and selections are all keyed by the
 * (variant pack, restaurant) pair — a row spanning many variant packs and many
 * restaurants is only identified by the pair. This is the one place that knows
 * the key's shape; build and parse keys here rather than inlining the format.
 */

interface AccountPair {
  restaurantUUID: string;
  variantPackUUID: string;
}

const SEPARATOR = ':';

/** Accepts rows and pricing edits alike. */
export const buildAccountKey = ({
  restaurantUUID,
  variantPackUUID,
}: AccountPair): string => `${variantPackUUID}${SEPARATOR}${restaurantUUID}`;

export const splitAccountKey = (key: string): AccountPair => {
  const [variantPackUUID = '', restaurantUUID = ''] = key.split(SEPARATOR);
  return { restaurantUUID, variantPackUUID };
};
